// Datas "só dia" (data da reunião, prazo de tarefa) vêm do banco como
// 2026-07-02T00:00:00.000Z. Passar isso por `new Date(...).toLocaleDateString()`
// no fuso -3 devolve 01/07 — um dia antes. Por isso formatamos a partir do texto,
// sem passar por fuso nenhum.
export function formatarData(d) {
  if (!d) return null;
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const dt = new Date(s);
  return isNaN(dt.getTime()) ? null : dt.toLocaleDateString('pt-BR');
}

// Valor pro <input type="date"> — mesmo motivo: corta o texto, não converte.
export function paraInputData(d) {
  const m = String(d || '').match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : '';
}

// Comparação de prazo vencido sem fuso atrapalhar (prazo é o dia inteiro).
export function estaAtrasado(prazo) {
  const p = paraInputData(prazo);
  if (!p) return false;
  return p < new Date().toISOString().slice(0, 10);
}
